export async function login(email) {
    return fetch(`api/v1/auth/_send_link${location.search}`, {
        body: email,
        method: 'POST',
    });
}
